<template>
  <a-spin :spinning="store.state.spinning">
    <router-view />
  </a-spin>
</template>
<script setup>
import { useStore } from "vuex";
const store = useStore();
</script>
<style lang="scss">
#app {
  @font-face {
    font-family: 'CustomMontserrat';
    src: url('~@/assets/font/Montserrat-Regular.ttf') format('truetype');
  }

  @font-face {
    font-family: 'CustomMontserratBold';
    src: url('~@/assets/font/Montserrat-Bold.ttf') format('truetype');
  }

  @font-face {
    font-family: 'gyrotropeBlack';
    src: url('~@/assets/font/Gyrotrope-Black.otf') format('truetype');

  }
  .ant-spin{
    max-height: 100vh;
    .ant-spin-dot-item{
      background-color: #333333;
    }
  }
}
</style>
